import { getMessages } from '../../../../../../../store/constants';
import { CLASS_ASIDE_PANEL_ACTIONS_POPUP } from '../../../../asidePanel/components/AsidePanelActionsButton/constants';

export const CLASS_BOARD_MOVE_TO = CLASS_ASIDE_PANEL_ACTIONS_POPUP + '__board-move-to';
export const BOARD_BUTTON_MOVE_TO = getMessages().getText('board_details__link_move_to');
export const EMPTY_MOVE_TO = getMessages().getText('board_details__link_move_to_empty');
export const DRIVES_COLUMN_TITLE = getMessages().getText('move_to_drives_column_title');
